import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "wrapper"];
  static values = { "hideToggle": Boolean }

  show(event) {
    event.preventDefault()

    const template = this.element.querySelector("template")
    const wrapperDiv = document.createElement("div")
    const content = template.content.cloneNode(true)
    const targetElement = this.hasWrapperTarget ? this.wrapperTarget : this.element

    wrapperDiv.classList.add("toggled-content")
    wrapperDiv.append(content)

    if (this.hideToggleValue && this.hasToggleTarget) {
      this.toggleTarget.hidden = true
    }
    targetElement.append(wrapperDiv)
  }

  hide(event) {
    event.preventDefault()

    event.target.closest(".toggled-content").remove()
    if (this.hideToggleValue && this.hasToggleTarget) {
      this.toggleTarget.hidden = false
    }
  }
}
